import SeleccionarSolucionLayout from "../../layouts/SeleccionarSolucion/SeleccionarSolucionLayout"
import {
    Stack,
    Box,
    Typography,
    Card,
    CardActionArea,
    Popover,
  } from "@gti-controls-v2/web-core";
import seleciconarSolucionStyles from "../../common/styles/SeleccionarSolucion";
import LogoRevolution from "../../assets/Logo-Revolution.png"
import LogoSistemaTress from "../../assets/Logo-Sistema-Tress.png"
import LogoInteris from "../../assets/Logo-Interis-Color.svg"
import { paths } from "../../common/constants/Rutas";
import { useNavigate } from "react-router-dom";
import { React, useState } from 'react'



export const SeleccionarSolucion = () => {

    const styles = seleciconarSolucionStyles;

    const navigate = useNavigate();

    const [popoverOpen, setPopoverOpen] = useState(null);
    
    const handleClosePopover = () => {
        setPopoverOpen(null);
      };

    const onLoginSistemaTress = (event) => {
        //navigate(paths.LoginSistemaTress, {replace: true} );
        setPopoverOpen(event.currentTarget);
    }

    const onLoginRevolution = () => {
        navigate(paths.Login, {replace: true} );
    }

    const onLoginInteris = (event) => {
        //navigate(paths.LoginInteris, {replace: true} );
        setPopoverOpen(event.currentTarget);
    }

    return (
        <SeleccionarSolucionLayout>

            <div>
                <Popover
                    open={popoverOpen}
                    anchorEl={popoverOpen}
                    onClose={handleClosePopover}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'left',
                    }}
                >
                    <Typography variant="h5" sx={{ p: 2, backgroundColor:"#fff" }}>Esta funcionalidad se encuentra en construcción.</Typography>
                </Popover>
            </div>

            <Box sx={styles.breadCrumb}>
                <Typography  sx={ styles.headerTitle } >Selecciona tu solución</Typography>                
            </Box>
            
            <Box spacing={{ xs: 1, sm: 2, md: 4 }}
                    justifyContent="center"
                    alignItems="center"
                    height="75%"
                    >
                <Stack 
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="center"
                    alignItems="center"
                    height={{sm:"100%"}}
                >
                    <Box sx={{ width:{xs:"90%", sm:322}, height:{xs:200, sm:322}, m:2}}>
                        <Card >
                            <CardActionArea sx={{ width:{xs:"100%", sm:322}, height:{xs:200, sm:322}}}
                                onClick={onLoginSistemaTress}>
                                <Box padding="16px">
                                    <img src={LogoSistemaTress} alt="" width="100%" />
                                </Box>
                            </CardActionArea>
                        </Card>
                    </Box>
                    <Box sx={{ width:{xs:"90%", sm:322}, height:{xs:200, sm:322}, m:2}} justifyContent="center">
                        <Card >
                            <CardActionArea 
                                sx={{ width:{xs:"100%", sm:322}, height:{xs:200, sm:322}}}
                                onClick={onLoginRevolution}
                                >
                                <Box padding="16px">
                                    <img src={LogoRevolution} alt="" width="100%" />
                                </Box>
                            </CardActionArea>
                        </Card>
                    </Box>
                    <Box sx={{ width:{xs:"90%", sm:322}, height:{xs:200, sm:322}, m:2}}>
                        <Card >
                            <CardActionArea sx={{ width:{xs:"100%", sm:322}, height:{xs:200, sm:322}}}
                                onClick={onLoginInteris}
                                >
                                <Box padding="16px">
                                    <img src={LogoInteris} alt="" width="100%" />
                                </Box>
                            </CardActionArea>
                        </Card>
                    </Box>
                </Stack>
            </Box>

        </SeleccionarSolucionLayout>
    )
}

export default SeleccionarSolucion;